import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.find.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations } from 'vuex';
export default {
  name: 'TheSorts',
  props: {
    inlined: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      methods: [{
        key: 'popular',
        sortBy: 'popular',
        orderBy: null
      }, {
        key: 'publishdate',
        sortBy: 'publishdate',
        orderBy: null
      }, {
        key: 'priceAscending',
        sortBy: 'price',
        orderBy: 'asc'
      }, {
        key: 'priceDescending',
        sortBy: 'price',
        orderBy: 'desc'
      }],
      selected: {
        key: 'popular',
        sortBy: 'popular',
        orderBy: null
      }
    };
  },
  methods: _objectSpread(_objectSpread({}, mapMutations({
    sortBy: 'pageActions/SORT_BY',
    orderBy: 'pageActions/ORDER_BY'
  })), {}, {
    tracking: function tracking(e) {
      var _this = this;

      var events = [{
        method: 'popular',
        event: 'Tri_Pertinence'
      }, {
        method: 'publishdate',
        event: 'Tri_Nouveaute'
      }, {
        method: 'priceAscending',
        event: 'Tri_Croissant'
      }, {
        method: 'priceDescending',
        event: 'Tri_Decroissant'
      }];
      var action = events.find(function (entry) {
        return entry.method === _this.selected.key;
      }).event;
      var tag = {
        data: {
          event_category: window.tc_vars.env_template === 'listproduct_keyword' ? 'Search Page' : 'Categorie',
          event_action: action,
          event_label: "".concat(window.tc_vars.page_cat1, "_").concat(window.tc_vars.page_cat3)
        }
      };
      this.$root.$emit('generic-tracking', e, tag);
    },
    isActive: function isActive(arg) {
      return arg === this.selected.key;
    }
  })
};